import { FC } from "react";

import { BookingsCalendar } from "../calendar";
import { BookingCrudeRoutes } from "../routes";
import { CalendarPanelWrapperStyled } from "./bookings.panel.styled";

export const BookingsPanelCalendar: FC = () => {
  return (
    <>
      <CalendarPanelWrapperStyled>
        <BookingsCalendar />
      </CalendarPanelWrapperStyled>
      <BookingCrudeRoutes />
    </>
  );
};
